import { isNumber } from 'lodash'
import { Charges, Fee, FeeType, TradeFormValues } from '../Types'
import { assembleFee } from './assembleFee'

const assembleFees = (
  clientClearingFee?: number,
  generalPurposeFee?: number,
  liquidityFee?: number,
  tradeActivityFee?: number
): Fee[] => {
  return [
    assembleFee(FeeType.ClientClearing, clientClearingFee),
    assembleFee(FeeType.GeneralPurpose, generalPurposeFee),
    assembleFee(FeeType.Liquidity, liquidityFee),
    assembleFee(FeeType.TradeActivity, tradeActivityFee),
  ].filter((fee): fee is Fee => fee !== undefined)
}

export const assembleCharges = ({
  commission,
  markUpMarkDown,
  clientClearingFee,
  generalPurposeFee,
  liquidityFee,
  tradeActivityFee,
}: TradeFormValues): { charges: Charges } | undefined => {
  const hasCharges: boolean = isNumber(commission) || isNumber(markUpMarkDown)
  const hasFees: boolean = [clientClearingFee, generalPurposeFee, liquidityFee, tradeActivityFee].some(isNumber)

  return hasCharges || hasFees
    ? {
        charges: {
          ...(isNumber(commission) && { commissionAmount: commission }),
          ...(isNumber(markUpMarkDown) && { priceAdjustmentAmount: markUpMarkDown }),
          ...(hasFees && {
            fees: assembleFees(clientClearingFee, generalPurposeFee, liquidityFee, tradeActivityFee),
          }),
        },
      }
    : undefined
}
